
<template>
  <div>
    <v-layout wrap pb-3 pb-sm-0>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <v-carousel
          continuous
          cycle
          v-model="slideno"
          :interval="slideinterval"
          height="100%"
          hide-delimiters
        >
          <v-sheet>
            <v-carousel-item v-for="(item, i) in photos" :key="i">
              <v-img
                :style="
                  $vuetify.breakpoint.name == 'lg'
                    ? 'height: 690px'
                    : (style = 'height: 100px')||
                    $vuetify.breakpoint.name == 'md'
                    ? 'height: 320px'
                    : (style = 'height: 100px')
                "
              cover
                :src="require('../../assets/' + item + '.jpg')"
              >
                <Header3 />
                <v-layout
                  wrap
                  fill-height
                  pb-lg-10
                  pb-md-10
                  class="d-none d-sm-flex"
                >
                  <v-flex
                    align-self-end
                    text-left
                    xs12
                    sm6
                    md5
                    pb-md-1
                    pb-xs-12
                  >
                    <div class="rectangle2">
                      <v-layout wrap justify-center>
                        <v-flex pl-lg-8 class="d-none d-sm-flex">
                          <span class="bannernotXStriangle1">
                            A citizen science initiative to record the turtle
                            biodiversity present in India
                          </span>
                        </v-flex>
                        <v-flex pl-lg-8 class="hidden-sm-and-up">
                          <span class="bannerXStriangle1">
                            A citizen science initiative to record the turtle
                            biodiversity present in India
                          </span>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>

                  <v-flex lg1 align-self-end>
                    <v-layout wrap justify-center>
                      <v-flex class="triangle-rights3"></v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout justify-end class="hidden-sm-and-up">
                  <v-flex align-self-end text-center xs12>
                    <p class="bannerXSRECT1">
                      <span>
                        A citizen science initiative to record the turtle
                        biodiversity present in India
                      </span>
                    </p>
                  </v-flex>
                  <v-flex align-self-center> </v-flex>
                </v-layout>
              </v-img>
            </v-carousel-item>
          </v-sheet>
        </v-carousel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Header3 from "../Header3";
export default {
  components: {
    Header3,
  },
  data() {
    return {
      slideno: 0,
      slideinterval: 4000,
      photos: ["1", "2", "3", "4"],
    };
  },
};
</script>

<style>
.rectangle2 {
  height: 100px;
  width: 100%;
  padding: 2%;
  background-color: rgba(255, 191, 0, 0.7);
  opacity: 0.8;
}
/* .triangle-right1 {
  width: 0;
  height: 0;
  border-top: 35px solid #3165dd;
  border-left: 50px solid #ffbf00;
  border-bottom: 35px solid #3165dd;
  background-color: #3165dd;
  opacity: 0.8;
} */
/* .triangle-right2 {
  width: 0;
  height: 0;
  border-top: 35px solid transparent;
  border-left: 50px solid #3165dd;
  border-bottom: 35px solid transparent;
  opacity: 0.8;
} */

.triangle-rights {
  width: 0;
  height: 0;
  border-top: 45px solid rgba(49, 101, 221, 0.16);
  border-left: 100px solid rgba(255, 191, 0, 0.94);
  border-bottom: 45px solid rgba(49, 101, 221, 0.16);
  opacity: 0.8;
  background-color: rgba(49, 101, 221, 0.56);
}
.triangle-rights2 {
  width: 0;
  height: 0;
  border-top: 45px solid transparent;
  border-left: 90px solid rgba(49, 101, 221, 0.66);
  border-bottom: 45px solid transparent;
  opacity: 0.8;
}
.triangle-rights3 {
  width: 0;
  height: 0;
  border-top: 55px solid transparent;
  border-left: 90px solid rgba(255, 191, 0, 0.7);
  border-bottom: 50px solid transparent;
  opacity: 0.8;
}
.rectangles {
  height: 90px;
  width: 200px;
  background-color: rgba(49, 101, 221, 0.66);
  opacity: 0.8;
}
</style>